import { render, staticRenderFns } from "./layout-widget-shop-default.vue?vue&type=template&id=26330e2d"
import script from "./layout-widget-shop-default.vue?vue&type=script&lang=ts"
export * from "./layout-widget-shop-default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports